.root {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  padding: var(--space-10) var(--space-6);
  text-align: center;
}

.sm {
  padding: var(--space-6) var(--space-4);
}

.icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  margin-bottom: var(--space-2);
  color: var(--color-link);
}

.icon > svg {
  width: 2rem;
  height: 2rem;
}

.sm .icon {
  width: 2.5rem;
  height: 2.5rem;
}

.title {
  color: var(--color-heading);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
}

.sm .title {
  font-size: var(--font-size-md);
}

.description {
  max-width: 28rem;
  color: var(--color-text-muted);
  font-size: var(--font-size-sm);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--space-2);
  margin-top: var(--space-3);
}
